<template>
    <b-modal
        v-model="clientDataModal"
        size="xl"
        header-bg-variant="dark"
        header-text-variant="light"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        >
        <template v-slot:modal-title>
            <div class="pb-2">Confirmar Pedido</div>
        </template>
        <b-row>
            <b-col cols="12">
                <p class="font-weight-medium">Por favor ingrese los datos del cliente para realizar el pedido, tenga en cuenta que todos los datos son requeridos..</p>
                <p class="font-weight-bold">Si necesita agregar un comentario al pedido, por favor use la opcion de comentario en la pagina anterior</p>
            </b-col>
            <b-col cols="12" md="6">
                <label>Nombre Completo</label>
                <b-form-input v-model="clientData.cliente" placeholder="Nombre Completo"></b-form-input>
            </b-col>
            <b-col cols="12" md="6">
                <label>Correo Electrónico</label>
                <b-form-input v-model="clientData.correo" placeholder="Correo Electrónico"></b-form-input>
            </b-col>
            <b-col cols="12" md="3">
                <label for="departamento">Tipo Documento</label>
                    <b-form-group>
                        <b-form-select
                        v-model="clientData.tipo_documento"
                        :options="tipoDocumento"
                        id="departamento"
                        class="mb-3"
                        value-field="tipo"
                        text-field="label"
                        disabled="disabled"
                        >
                        <template #first>
                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="3">
                <label>Número de Documento</label>
                <b-form-input v-model="clientData.documento" disabled="disabled" placeholder="Número Documento"></b-form-input>
            </b-col>
             <b-col cols="12" md="6">
                <label>Número Teléfono</label>
                <b-form-input v-model="clientData.telefono" placeholder="Número Teléfono"></b-form-input>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group 
                    label="Departamento:"
                    label-for="departamento">
                    <b-form-select
                        v-model="clientData.departamento_id"
                        :options="departamentos_list"
                        id="departamento"
                        class="mb-3"
                        value-field="id"
                        text-field="nombre"
                        @change="getCiudadesList()"
                        >
                        <template #first>
                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group 
                    label="Ciudad:"
                    label-for="ciudad">
                    <b-form-select
                        v-model="clientData.ciudad_id"
                        :options="ciudades_list"
                        id="ciudad"
                        class="mb-3"
                        value-field="id"
                        text-field="nombre"
                        >
                        <template #first>
                            <b-form-select-option value="">SELECCIONE</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="12" >
                <label>Dirección</label>
                <b-form-textarea
                    v-model="clientData.direccion"
                    placeholder="Ingrese la Dirección..."
                    rows="3"
                    max-rows="6"
                ></b-form-textarea>
            </b-col>
            <b-col cols="12">
                <b-alert show variant="danger" v-if="clientFormValidateError.length > 0">
                    <ul >
                        <li v-for="(item, index) in clientFormValidateError" :key="index">{{ item }}</li>
                    </ul>
                </b-alert>
            </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button variant="danger" @click.prevent="$emit('close-modal', false)">
                Cancelar
            </b-button>
            <b-button variant="success" @click.prevent="storePedido(clientData)">
                Procesar
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import {  mapMutations } from 'vuex'
export default {
    name: "ClientFormModal",
    props: {
        clientDataModal: {
            type: Boolean
        },
        clientData: {
            type: Object
        },
        tipoDocumento: {},
        comentario: {
            type: String
        }

    },
    data(){
        return{
            departamentos_list: [],
            ciudades_list: [],
            clientFormValidateError: []
        }
    },
    created(){
        this.getDepartamentosList();
        this.getCiudadesList();
    },
    methods: {
        ...mapMutations(['setLoading']),
        verSi(clientData){
            console.log(clientData)
        },
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentos_list = response.data.departamentosList;
                this.getCiudadesList();
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            this.departamentoSelected = { 
                departamento_id:   this.clientData.departamento_id, 
            }
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
            .then(response =>{
                this.ciudades_list = response.data.ciudadesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async storePedido(clientData){
            this.setLoading(true)
            this.clientFormValidateError = [];
            clientData['comentario'] = this.comentario;
            await this.$conectar.post('cart/store-pedido', clientData)
            .then(response => {
                if(response.data.errors){
                    this.clientFormValidateError = response.data.errors;
                }else{
                    if(response.data.error == false){
                        this.$root.$bvToast.toast('Su pedido ha sido registrado exitosamente', {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                        })
                    }else{
                        this.$root.$bvToast.toast('Error al tratar de registrar su pedido, por favor verifique y vuelva a intentarlo.', {
                            title: "Respuesta del servidor",
                            variant: "danger",
                            solid: true
                        })
                    }
                    //the params true is use to check cart count ammount,
                    this.$emit('close-modal', true);
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
            
        },
    }
};

</script>
<style scoped>

</style>